export const masterConstants = {

    LOGIN_REQUEST: "POST_LOGIN_REQUEST",
    LOGIN_SUCCESS: "POST_LOGIN_SUCCESS",
    LOGIN_FAILURE: "POST_LOGIN_FAILURE", 
    
    ISLOGGED_IN_REQUEST: "ISLOGGED_IN_REQUEST",
    ISLOGGED_IN_SUCCESS: "ISLOGGED_IN_SUCCESS",
    ISLOGGED_IN_FAILURE: "ISLOGGED_IN_FAILURE",
};
